import { Autocomplete, Box, Button, Card, CardContent, Chip, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, IconButton, MenuItem, Paper, Stack, styled, Switch, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Domains from '../../global/constants/domain';
import { ApiCreateBusinessChecklist, ApiGetBusinessChecklist, ApiUpdateBusinessChecklist, ApiCheckListCreation } from '../../apiService/Core/Apicall';
import storage from '../../utils/storage';
import { useSelector } from 'react-redux';
import { RootState } from '../../global/config/Reducer';
import { toast } from 'react-toastify';
import { CancelOutlined, Delete, Edit, EditOutlined, EmailOutlined, EventRepeatOutlined, ListAltOutlined, ScheduleOutlined, NoteAdd } from '@mui/icons-material';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';



const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F79';
    if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
    if (domain.includes(Domains.MM)) return '#ADB792';

    return '#ADB792';
};

const primary_color = getIconColorByDomain()

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: primary_color,
        color: theme.palette.common.white,
        padding: "10px 20px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: " 10px 20px",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: `${primary_color}1A`,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



function ChecklistList() {
    const [AllChecklist, setAllChecklist] = useState<any>(null)
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [selectedChecklist, setSelectedChecklist] = useState<any>(null);
    const [filterType, setFilterType] = useState<string>("BUSINESS");
    const navigate = useNavigate()

    const getChecklist = async () => {
        try {
            const offset = page * rowsPerPage;

            const data = `?offset=${offset}&limit=${rowsPerPage}&clientEntityId=${isGroupScore
                ? clientEntityIds
                : storage.getItem('clientEntityId')
                }&isActive=true&type=${filterType}`;

            const res = await ApiGetBusinessChecklist(data);

            if (res?.status) {
                setAllChecklist(res?.data || []);
                setTotalCount(res?.totalCount || res?.count || 0);
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong");
        }
    };


    useEffect(() => {
        clientEntity && getChecklist()
    }, [isGroupScore, clientEntity, page, rowsPerPage, filterType])


    const validationSchema = Yup.object({
        checklistName: Yup.string()
            .required("Checklist name is required"),

        checklistDescription: Yup.string()
            .required("Checklist description is required"),

        emailIds: Yup.array()
            .min(1, "At least one email is required")
            .of(Yup.string().email("Invalid email address")),

        type: Yup.string()
            .required("Checklist type is required"),

        scheduleType: Yup.string()
            .required("Schedule type is required"),

        requiredCount: Yup.number()
            .when("scheduleType", {
                is: (scheduleType: string) => scheduleType !== "INTERVAL_DAYS",
                then: (schema) =>
                    schema
                        .required("Required count is required")
                        .min(1, "Must be at least 1")
                        .integer("Must be a whole number"),
                otherwise: (schema) => schema.notRequired(),
            }),

        intervalDays: Yup.number()
            .when("scheduleType", {
                is: "INTERVAL_DAYS",
                then: (schema) =>
                    schema
                        .required("Interval days is required")
                        .min(1, "Must be at least 1")
                        .integer("Must be a whole number"),
                otherwise: (schema) => schema.notRequired(),
            }),

        scheduleDay: Yup.number()
            .when("scheduleType", {
                is: (scheduleType: string) =>
                    ["WEEKLY", "MONTHLY", "BI_MONTHLY", "QUARTERLY", "HALF_YEARLY", "YEARLY"]
                        .includes(scheduleType),
                then: (schema) =>
                    schema
                        .required("Schedule day is required")
                        .when("scheduleType", {
                            is: "WEEKLY",
                            then: (weeklySchema) =>
                                weeklySchema
                                    .min(0, "Select a valid day")
                                    .max(6, "Select a valid day")
                                    .integer("Select a valid day"),
                            otherwise: (otherSchema) =>
                                otherSchema
                                    .min(1, "Date must be between 1 and 31")
                                    .max(31, "Date must be between 1 and 31")
                                    .integer("Date must be a whole number"),
                        }),
                otherwise: (schema) => schema.notRequired(),
            }),
    });


    const formik = useFormik({
        initialValues: {
            checklistName: selectedChecklist?.businessCheckListTitle || "",
            checklistDescription:
                selectedChecklist?.businessCheckListDesc || "",
            emailIds: selectedChecklist?.emailIds
                ? selectedChecklist.emailIds.split(",")
                : [],
            scheduleType: selectedChecklist?.scheduleType || "",
            requiredCount: selectedChecklist?.requiredCount || 1,
            intervalDays: selectedChecklist?.intervalDays || "",
            type: selectedChecklist?.type || "BUSINESS",
            scheduleStartDate: selectedChecklist?.scheduleStartDate || "",
            scheduleDay: selectedChecklist?.scheduleDayOfMonth || selectedChecklist?.scheduleDayOfWeek || "",
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            const payload = {
                businessCheckListTitle: values.checklistName,
                businessCheckListDesc: values.checklistDescription,
                emailIds: values.emailIds.join(","),
                clientEntityId: clientEntity,
                type: values.type,
                scheduleType: values.scheduleType,
                scheduleStartDate: dayjs(values.scheduleStartDate).format("YYYY-MM-DD"),
                ...(selectedChecklist && { businessCheckListId: selectedChecklist?.businessCheckListId }),
                // ...(values.scheduleType === "DAILY" ? { requiredCount: values.requiredCount } : { intervalDays: values.intervalDays })
                ...(values.scheduleType === "INTERVAL_DAYS"
                    ? { intervalDays: values.intervalDays }
                    : {
                        requiredCount: values.requiredCount,
                        ...(values.scheduleType === "WEEKLY"
                            ? { scheduleDayOfWeek: values.scheduleDay }
                            : !["DAILY"].includes(values.scheduleType)
                                ? { scheduleDayOfMonth: values.scheduleDay }
                                : {}),
                    }),
            };

            if (!selectedChecklist) {
                try {
                    const res = await ApiCreateBusinessChecklist(payload)
                    if (res?.status) {
                        handleClose()
                        getChecklist()
                    }
                } catch (error: any) {
                    toast.error(error?.message || "something went wrong")
                }
            } else {
                try {
                    const res = await ApiUpdateBusinessChecklist(payload)
                    if (res?.status) {
                        handleClose()
                        getChecklist()
                    }
                } catch (error: any) {
                    toast.error(error?.message || "something went wrong")
                }
            }

            // API Call Here
        },
    });

    const handleClose = () => {
        setOpen(false);
        setSelectedChecklist(null);
        formik.resetForm();
    };

    const handleDeleteChecklist = async (businessCheckListId: number) => {
        const isConfirm = window.confirm("Are you sure you want to delete this checklist?")
        if (!isConfirm) return;
        try {
            const data = { isActive: false, businessCheckListId: businessCheckListId }
            const res = await ApiUpdateBusinessChecklist(data)
            if (res?.status) {
                getChecklist()
            }
        } catch (error: any) {
            toast.error(error?.message || "spmething went wrohg")
        }
    }


    const getIconColorByDomain2 = () => {
        const domain = window.location.hostname;

        if (domain.includes(Domains.MM))
            return {
                daily: "#ADB792",
                interval: "#7C9FB2",
            };
        else if (domain.includes(Domains.BLOOMS))
            return {
                daily: "#1C2B90",
                interval: "#2BB572",
            };
        else if (domain.includes(Domains.ALDI))
            return {
                daily: "#001F79",
                interval: "#F96E09",
            };

        else return {
            daily: "#ADB792",
            interval: "#7C9FB2",
        };;
    };

    const themeColors = getIconColorByDomain2()
    const scheduleTypeColors: Record<string, string> = {
        QUARTERLY: "#8E44AD",   // Purple
        BI_MONTHLY: "#E84393",  // Pink
        MONTHLY: "#E67E22",     // Orange
        HALF_YEARLY: "#16A085", // Teal
        YEARLY: "#D4AC0D",      // Golden yellow
    };

    const getChecklistColor = (type?: string) => {
        switch (type) {
            case "DAILY":
                return themeColors?.daily;
            case "INTERVAL_DAYS":
                return themeColors?.interval;
            default:
                return scheduleTypeColors[type ?? ""] ?? themeColors.daily;
        }
    };

    const getScheduleLabel = (checklist: any) => {
        if (checklist?.scheduleType === "DAILY") {
            return `${checklist?.requiredCount || 1} time${checklist?.requiredCount > 1 ? "s" : ""} per day`;
        }

        if (checklist?.scheduleType === "INTERVAL_DAYS") {
            return `Every ${checklist?.intervalDays || 1} day${checklist?.intervalDays > 1 ? "s" : ""}`;
        }

        return "Manual";
    };

    return (
        <>

            <Box className="w-100 h-100 extra">
                <Box className="d-flex w-100 mb-4 align-items-center gap-3 justify-content-between">
                    <Box className="d-flex align-items-center gap-3">
                        <TextField
                            select
                            size="small"
                            label="Filter by Checklist"
                            value={filterType}
                            onChange={(e) => {
                                setFilterType(e.target.value);
                                setPage(0);
                            }}
                            sx={{ minWidth: 200, bgcolor: "white" }}
                        >
                            <MenuItem value="BUSINESS">Sites</MenuItem>
                            <MenuItem value="AREA_MANAGER">Areas</MenuItem>
                        </TextField>

                        {(storage.getItem("ClientGroupName") === "MM" ||
                            storage.getItem("ClientGroupName") === "EXTENDED" ||
                            storage.getItem("ClientGroupName") === "JBHIFI") &&
                            storage.getItem("userRole") === "clientadmin" && (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isGroupScore}
                                            onChange={(e) => setisGroupScore(e.target.checked)}
                                        />
                                    }
                                    label="Whole Group"
                                />
                            )}
                    </Box>

                    <Box className="d-flex align-items-center gap-3">
                        <Button
                            className="btn-main px-4"
                            sx={{ whiteSpace: "nowrap" }}
                            onClick={() => {
                                setSelectedChecklist(null);
                                setOpen(true);
                            }}
                        >
                            New Checklist
                        </Button>
                        <Button
                            className="btn-main px-5"
                            sx={{ whiteSpace: "nowrap" }}
                            onClick={() => {
                                navigate('/maindashboard/Checklist/create-new-checklist')
                            }}
                        >
                            Create from Template
                        </Button>
                    </Box>
                </Box>
                {AllChecklist?.length > 0 ? (
                    <>
                        <Grid className='flex-1' container spacing={3}>
                            {AllChecklist.map((checklist: any, index: number) => {
                                const color = getChecklistColor(checklist?.scheduleType);
                                return (
                                    <Grid size={{ xs: 12, md: 6, lg: 4 }} key={checklist?.businessCheckListId || index}>
                                        <Card
                                            elevation={0}
                                            sx={{
                                                height: "100%",
                                                borderRadius: "18px",
                                                border: `1px solid ${color}55`,
                                                background: `linear-gradient(145deg, ${color}24 0%, #ffffff 55%, ${color}16 100%)`,
                                                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <CardContent sx={{ p: 3 }}>
                                                <Box className="d-flex justify-content-between align-items-start mb-3">
                                                    <Box
                                                        sx={{
                                                            width: 52,
                                                            height: 52,
                                                            borderRadius: "14px",
                                                            backgroundColor: color,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            color: "#fff",
                                                        }}
                                                    >
                                                        {checklist?.scheduleType === "INTERVAL_DAYS" ? (
                                                            <ScheduleOutlined />
                                                        ) : (
                                                            <EventRepeatOutlined />
                                                        )}
                                                    </Box>

                                                    <Chip
                                                        label={checklist?.scheduleType || "MANUAL"}
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: `${color}30`,
                                                            color,
                                                            fontWeight: 700,
                                                        }}
                                                    />
                                                </Box>

                                                <Tooltip title={checklist?.businessCheckListTitle || ""} arrow>
                                                    <Typography
                                                        variant="h6"
                                                        sx={{
                                                            fontWeight: 700,
                                                            mb: 1,
                                                            color: "#1f2937",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        {checklist?.businessCheckListTitle}
                                                    </Typography>
                                                </Tooltip>

                                                <Tooltip title={checklist?.businessCheckListDesc || ""} arrow>
                                                    <Typography
                                                        sx={{
                                                            color: "#4b5563",
                                                            minHeight: 44,
                                                            mb: 2,
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                        }}
                                                    >
                                                        {checklist?.businessCheckListDesc || "-"}
                                                    </Typography>
                                                </Tooltip>

                                                <Tooltip
                                                    title={
                                                        <Box>
                                                            {checklist?.emailIds
                                                                ?.split(",")
                                                                ?.map((email: string, i: number) => (
                                                                    <Typography key={i} variant="caption" display="block">
                                                                        {email.trim()}
                                                                    </Typography>
                                                                ))}
                                                        </Box>
                                                    }
                                                    arrow
                                                >
                                                    <Box className="d-flex align-items-center gap-2 mb-3">
                                                        <EmailOutlined sx={{ fontSize: 18, color: "#6b7280" }} />
                                                        <Typography
                                                            sx={{
                                                                fontSize: 14,
                                                                color: "#374151",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {checklist?.emailIds || "-"}
                                                        </Typography>
                                                    </Box>
                                                </Tooltip>

                                                <Box
                                                    sx={{
                                                        borderTop: "1px solid #e5e7eb",
                                                        pt: 2,
                                                        mt: 2,
                                                    }}
                                                >
                                                    <Box className="d-flex justify-content-between mb-2">
                                                        <Typography sx={{ color: "#6b7280" }}>CheckList View</Typography>
                                                        <Typography sx={{ fontWeight: 700, color }}>
                                                            {checklist?.type === "AREA_MANAGER" ? "Areas" : "Sites"}
                                                        </Typography>
                                                    </Box>

                                                    <Box className="d-flex justify-content-between mb-2">
                                                        <Typography sx={{ color: "#6b7280" }}>Schedule Type</Typography>
                                                        <Typography sx={{ fontWeight: 700, color }}>
                                                            {checklist?.scheduleType}
                                                        </Typography>
                                                    </Box>

                                                    <Box className="d-flex justify-content-between mb-2">
                                                        <Typography sx={{ color: "#6b7280" }}>
                                                            {checklist?.scheduleType === "INTERVAL_DAYS"
                                                                ? "Interval Gap"
                                                                : "Daily Repeat"}
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 700, color }}>
                                                            {getScheduleLabel(checklist)}
                                                        </Typography>
                                                    </Box>

                                                    <Box className="d-flex justify-content-between">
                                                        <Typography sx={{ color: "#6b7280" }}>Status</Typography>
                                                        <Chip
                                                            label={checklist?.isActive ? "Active" : "Inactive"}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: checklist?.isActive ? "#e6f4ea" : "#f3f4f6",
                                                                color: checklist?.isActive ? "#137333" : "#6b7280",
                                                                fontWeight: 700,
                                                            }}
                                                        />
                                                    </Box>
                                                </Box>
                                            </CardContent>

                                            <Box
                                                sx={{
                                                    px: 3,
                                                    py: 2,
                                                    backgroundColor: `${color}18`,
                                                    borderTop: `1px solid ${color}35`,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<ListAltOutlined />}
                                                    sx={{
                                                        borderColor: color,
                                                        color,
                                                        fontWeight: 700,
                                                        textTransform: "none",
                                                        borderRadius: "10px",
                                                    }}
                                                    onClick={() => {
                                                        navigate(
                                                            `/maindashboard/new-checklist/businesschecklistquestions/${checklist?.businessCheckListTitle}/${checklist?.businessCheckListId}`
                                                        );
                                                    }}
                                                >
                                                    Questions
                                                </Button>

                                                <Stack direction="row" spacing={1}>
                                                    <IconButton
                                                        onClick={async () => {
                                                            try {
                                                                const data = `?businessCheckListId=${checklist?.businessCheckListId}&type=${checklist?.type}`;
                                                                const res = await ApiCheckListCreation(data);
                                                                if (res?.status || res?.success) {
                                                                    toast.success(res?.message || "Checklist submission created successfully");
                                                                } else {
                                                                    toast.error(res?.message || "Failed to create checklist submission");
                                                                }
                                                            } catch (error: any) {
                                                                toast.error(error?.message || "An error occurred");
                                                            }
                                                        }}
                                                        sx={{
                                                            border: `1px solid ${color}66`,
                                                            color,
                                                        }}
                                                        title="Create Checklist Submission"
                                                    >
                                                        <NoteAdd />
                                                    </IconButton>

                                                    <IconButton
                                                        onClick={() => {
                                                            setSelectedChecklist(checklist);
                                                            setOpen(true);
                                                        }}
                                                        sx={{
                                                            border: `1px solid ${color}66`,
                                                            color,
                                                        }}
                                                    >
                                                        <EditOutlined />
                                                    </IconButton>

                                                    <IconButton
                                                        onClick={() =>
                                                            handleDeleteChecklist(checklist?.businessCheckListId)
                                                        }
                                                        sx={{
                                                            border: "1px solid #ef444466",
                                                            color: "#ef4444",
                                                        }}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </Stack>
                                            </Box>
                                        </Card>
                                    </Grid>
                                );
                            })}
                        </Grid>

                        <Paper
                            elevation={0}
                            sx={{
                                mt: 3,
                                borderRadius: "14px",
                                // border: "1px solid #e5e7eb",
                            }}
                        >
                            <TablePagination
                                component="div"
                                count={totalCount}
                                page={page}
                                onPageChange={(_, newPage) => setPage(newPage)}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={(event) => {
                                    setRowsPerPage(parseInt(event.target.value, 10));
                                    setPage(0);
                                }}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                            />
                        </Paper>
                    </>
                ) : (
                    <Paper
                        elevation={0}
                        sx={{
                            p: 5,
                            textAlign: "center",
                            borderRadius: "18px",
                            border: "1px solid #e5e7eb",
                        }}
                    >
                        <Typography variant="h5">No Data Found</Typography>
                    </Paper>
                )}
            </Box>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                sx={{ zIndex: "1302" }}
            >
                <form onSubmit={formik.handleSubmit}>
                    <DialogContent
                        className="p-4"
                        sx={{ paddingTop: "10px !important" }}
                    >
                        <Box className="d-flex justify-content-between my-4">
                            <Typography variant="h5">
                                {selectedChecklist ? "Update Checklist" : "Create Checklist"}
                            </Typography>
                            <IconButton onClick={() => handleClose()}>
                                <CancelOutlined />
                            </IconButton>
                        </Box>


                        <Box display="flex" flexDirection="column" gap={3}>
                            <TextField
                                fullWidth
                                label="Checklist Name"
                                name="checklistName"
                                value={formik.values.checklistName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.checklistName &&
                                    Boolean(formik.errors.checklistName)
                                }
                                helperText={
                                    formik.touched.checklistName &&
                                    typeof formik.errors.checklistName == "string" &&
                                    formik.errors.checklistName
                                }
                            />

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Checklist Description"
                                name="checklistDescription"
                                value={formik.values.checklistDescription}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.checklistDescription &&
                                    Boolean(formik.errors.checklistDescription)
                                }
                                helperText={
                                    formik.touched.checklistDescription &&
                                    typeof formik.errors.checklistDescription === "string" &&
                                    formik.errors.checklistDescription
                                }
                            />

                            <Autocomplete
                                multiple
                                freeSolo
                                options={[]}
                                value={formik.values.emailIds}
                                onChange={(_, value) =>
                                    formik.setFieldValue("emailIds", value)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Email IDs"
                                        placeholder="Type email and press Enter"
                                        error={
                                            formik.touched.emailIds &&
                                            Boolean(formik.errors.emailIds)
                                        }
                                        helperText={
                                            formik.touched.emailIds &&
                                                typeof formik.errors.emailIds === "string"
                                                ? formik.errors.emailIds
                                                : ""
                                        }
                                    />
                                )}
                            />

                            <TextField
                                select
                                fullWidth
                                label="CheckList View"
                                name="type"
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                disabled={Boolean(selectedChecklist)}
                                SelectProps={{
                                    MenuProps: {
                                        style: {
                                            zIndex: 1400,
                                        },
                                    },
                                }}
                                error={
                                    formik.touched.type &&
                                    Boolean(formik.errors.type)
                                }
                                helperText={
                                    formik.touched.type &&
                                        typeof formik.errors.type === "string"
                                        ? formik.errors.type
                                        : ""
                                }
                            >
                                <MenuItem value="BUSINESS">Sites</MenuItem>
                                <MenuItem value="AREA_MANAGER">Areas</MenuItem>
                            </TextField>

                            <TextField
                                select
                                fullWidth
                                label="Schedule Type"
                                name="scheduleType"
                                value={formik.values.scheduleType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                SelectProps={{
                                    MenuProps: {
                                        style: {
                                            zIndex: 1400,
                                        },
                                    },
                                }}
                                error={
                                    formik.touched.scheduleType &&
                                    Boolean(formik.errors.scheduleType)
                                }
                                helperText={
                                    formik.touched.scheduleType &&
                                        typeof formik.errors.scheduleType === "string"
                                        ? formik.errors.scheduleType
                                        : ""
                                }
                            >
                                <MenuItem value="DAILY">DAILY</MenuItem>
                                <MenuItem value="INTERVAL_DAYS">INTERVAL DAYS</MenuItem>
                                <MenuItem value="WEEKLY">WEEKLY</MenuItem>
                                <MenuItem value="MONTHLY">MONTHLY</MenuItem>
                                <MenuItem value="BI_MONTHLY">BI_MONTHLY</MenuItem>
                                <MenuItem value="QUARTERLY">QUARTERLY</MenuItem>
                                <MenuItem value="HALF_YEARLY">HALF_YEARLY</MenuItem>
                                <MenuItem value="YEARLY">YEARLY</MenuItem>
                            </TextField>

                            <TextField
                                fullWidth
                                type="date"
                                label="Start Date"
                                name="scheduleStartDate"
                                value={formik.values.scheduleStartDate}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    min: dayjs().format("YYYY-MM-DD"),
                                }}
                                error={
                                    formik.touched.scheduleStartDate &&
                                    Boolean(formik.errors.scheduleStartDate)
                                }
                                helperText={
                                    formik.touched.scheduleStartDate &&
                                        typeof formik.errors.scheduleStartDate === "string"
                                        ? formik.errors.scheduleStartDate
                                        : ""
                                }
                            />


                            {/* {formik.values.scheduleType === "DAILY" && ( */}
                            <TextField
                                fullWidth
                                type="number"
                                label="Required Count"
                                name="requiredCount"
                                value={formik.values.requiredCount}
                                inputProps={{ min: 1 }}
                                onChange={formik.handleChange}
                                error={
                                    formik.touched.requiredCount &&
                                    Boolean(formik.errors.requiredCount)
                                }
                                helperText={
                                    formik.touched.requiredCount &&
                                        typeof formik.errors.requiredCount === "string"
                                        ? formik.errors.requiredCount
                                        : ""
                                }
                            />
                            {/* )} */}

                            {["YEARLY", "HALF_YEARLY", "QUARTERLY", "BI_MONTHLY", "MONTHLY", "WEEKLY"].includes(
                                formik.values.scheduleType
                            ) && (
                                    <TextField
                                        select
                                        fullWidth
                                        label={formik.values.scheduleType === "WEEKLY" ? "Schedule Day" : "Schedule Date"}
                                        name="scheduleDay"
                                        value={formik.values.scheduleDay}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={
                                            formik.touched.scheduleDay &&
                                            Boolean(formik.errors.scheduleDay)
                                        }
                                        helperText={
                                            formik.touched.scheduleDay &&
                                                typeof formik.errors.scheduleDay === "string"
                                                ? formik.errors.scheduleDay
                                                : ""
                                        }
                                        SelectProps={{
                                            MenuProps: {
                                                style: {
                                                    zIndex: 1400,
                                                },
                                            },
                                        }}
                                    >
                                        {formik.values.scheduleType === "WEEKLY"
                                            ? [
                                                { label: "Sunday", value: 0 },
                                                { label: "Monday", value: 1 },
                                                { label: "Tuesday", value: 2 },
                                                { label: "Wednesday", value: 3 },
                                                { label: "Thursday", value: 4 },
                                                { label: "Friday", value: 5 },
                                                { label: "Saturday", value: 6 },
                                            ].map((day) => (
                                                <MenuItem key={day.value} value={day.value}>
                                                    {day.label}
                                                </MenuItem>
                                            ))
                                            : Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                                <MenuItem key={day} value={day}>
                                                    {day}
                                                </MenuItem>
                                            ))}
                                    </TextField>
                                )}
                            {formik.values.scheduleType === "INTERVAL_DAYS" && (
                                <TextField
                                    fullWidth
                                    type="number"
                                    label="Interval Days"
                                    name="intervalDays"
                                    value={formik.values.intervalDays}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.intervalDays &&
                                        Boolean(formik.errors.intervalDays)
                                    }
                                    helperText={
                                        formik.touched.intervalDays &&
                                            typeof formik.errors.intervalDays === "string"
                                            ? formik.errors.intervalDays
                                            : ""
                                    }

                                />
                            )}
                        </Box>
                    </DialogContent>

                    <DialogActions
                        sx={{
                            justifyContent: "space-between",
                            mx: 2,
                            mb: 2,
                            mt: 5
                        }}
                    >
                        <Button
                            variant="outlined"
                            className='btn-outlined'
                            onClick={() => handleClose()}
                            sx={{ width: "100%" }}
                        >
                            Cancel
                        </Button>

                        <Button
                            type="submit"
                            className='btn-main'
                            variant="contained"
                            sx={{ width: "100%" }}
                        >
                            {selectedChecklist ? "Update" : "Save"}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}

export default ChecklistList
